const capitalizeFirstLetter = (text: string = '') =>
  `${(text[0] || '').toUpperCase()}${text.slice(1)}`;

export default capitalizeFirstLetter;
